module.exports = __webpack_public_path__ + "static/media/bookmarkgrey.99827738.svg";